
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m/cne",
      function () {
        return require("private-next-pages/m/cne/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/m/cne"])
      });
    }
  